import ConfirmModal from '@components/modal/ConfirmModal';
import { useHistory, useParams } from 'react-router-dom';
import useDeleteChallenge from './hooks/useDeleteChallenge';

const DeleteChallengeModal = () => {
    const history = useHistory();
    const { challengeID } = useParams<DeleteChallengeParams>();
    const { challenge, handleSubmit, isDeleting, deleteError } = useDeleteChallenge(+challengeID);

    return (
        <ConfirmModal
            title="Delete Challenge"
            description={`Are you sure you want to delete the challenge '${challenge.name}'?`}
            closeModal={() => history.goBack()}
            handleSubmit={handleSubmit}
            isPosting={isDeleting}
            error={deleteError}
        />
    );
};

interface DeleteChallengeParams {
    challengeID: string;
}

export default DeleteChallengeModal;
